import React from 'react';

interface ProgressBarProps {
  totalSteps: number;
  currentStep: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ totalSteps, currentStep }) => {
  const progressWidth = (currentStep / totalSteps) * 100;

  return (
      <div
        className="h-0.5 bg-gradient-to-r from-purple-400 to-pink-400 rounded transition-all duration-500"
        style={{ width: `${progressWidth}%` }}
      ></div>
  );
}

export default ProgressBar;
